import { FunctionComponent } from 'react';
import { ComplexAction, MediaCard as ShopifyMediaCard } from '@shopify/polaris';
import styled, { css } from 'styled-components';

export interface MediaCardProps {
  description: string;
  onMediaClick?(): void;
  title: string | React.ReactNode;
  mediaSrc: string;
  primaryAction?: ComplexAction;
  secondaryAction?: ComplexAction;
  portrait?: boolean;
}

const Container = styled.div<{
  portrait?: boolean;
}>`
  margin-bottom: 2rem;

  .Polaris-Heading {
    font-size: 16px;
    font-weight: 600;
  }

  .Polaris-Card__Section {
    padding-top: ${(props) => (props.portrait ? '0' : undefined)};
  }
`;

const MediaContainer = styled.img<{
  portrait?: boolean;
  hasOnClick?: boolean;
}>`
  &:hover {
    cursor: ${(props) => (props.hasOnClick ? 'pointer' : undefined)};
  }

  max-height: 300px;
  object-fit: cover;
  width: 100%;

  ${(props) =>
    props.portrait &&
    css`
      padding: 2rem;
      border-radius: 2.5rem;
    `}
`;

const MediaCard: FunctionComponent<MediaCardProps> = (props) => {
  const { mediaSrc, onMediaClick, portrait, primaryAction } = props;

  return (
    <Container portrait={portrait}>
      <ShopifyMediaCard {...props} primaryAction={primaryAction}>
        <MediaContainer
          src={mediaSrc}
          onClick={onMediaClick}
          portrait={portrait}
          hasOnClick={onMediaClick !== undefined}
        />
      </ShopifyMediaCard>
    </Container>
  );
};

export default MediaCard;
